
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { AmazonRedshiftLinkedService } from '../linkedservice/amazon-redshift.linkedservice';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.amazonRedshift.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AmazonRedshift_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AmazonRedshift_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AmazonRedshiftLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AmazonRedshiftTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
